/** R1 address comparison key: fold EVM hex only; preserve other addresses and opaque node IDs. */
export function normalizeCanvasAddr(address: string): string {
  if (!address) return address;
  if (address.startsWith('0x') || address.startsWith('0X')) return address.toLowerCase();
  return address;
}
